import { parseISO, format, formatRelative } from 'date-fns'
import { enGB } from 'date-fns/locale'

/*
  @utilities/dates
*/

/**
 * Returns date in string format used by the API.
 */
export function formatDateToApiString(date: Date | null): string | null {
  if (!date) {
    return null
  }

  return date.toISOString().slice(0, 10)
}

/**
 *   Helper to get a date n years in the past (eg. -3) or future (eg. +1).
 */
export function getDateYearOffset(numberOfYearsToOffset: number) {
  return new Date(new Date().setFullYear(new Date().getFullYear() + numberOfYearsToOffset))
}

export function formatDate(s: string) {
  return s?.length > 0 ? formatRelative(parseISO(s), new Date(), { locale: enGB }) : ''
}
export function formatDateNice(s: string) {
  // console.log(parseISO(s), format(parseISO(s), {locale: enGB}))
  // eslint-disable-next-line quotes
  return s?.length > 0 ? format(parseISO(s), "do MMM ''yy", { locale: enGB }) : ''
}
